import { useStructureContext } from "../../../context/StructureContext";
import { stdObject } from "../../../data/types/stdObject";
import { headerTitles } from "../../../data/admin";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { useEffect, useState } from "react";
import { sendData } from "../../../services/sendData";
import { emptys } from "../../../data/main";

export default function HeadersBox() {
  const { type, searchValues, section, closeMsg } = useStructureContext();
  const [headersList, setHeadersList] = useState<stdObject[]>([]);
  const { setMsg, openHeaderInfo, logoutAction, customUpdate } =
    useMainContext();

  const callHeaders = async () => {
    setMsg("loading");
    const payloadHeaders = {
      group: emptys.includes(searchValues[section.id]?.GRUCAB?.value)
        ? "ART"
        : searchValues[section.id]?.GRUCAB?.value,
      user: emptys.includes(searchValues[section.id]?.USUCAB?.value)
        ? 0
        : searchValues[section.id]?.USUCAB?.value,
    };
    console.log("payloadHeaders", payloadHeaders);
    const responseHeaders: stdObject = await sendData({
      endPoint: "callHeader",
      payload: payloadHeaders,
      logoutAction,
    });
    console.log("responseHeaders", responseHeaders);
    if (responseHeaders.success && responseHeaders.status) {
      setHeadersList(responseHeaders.headers);
    }
    closeMsg();
  };

  useEffect(() => {
    callHeaders();
  }, []);

  useEffect(() => {
    callHeaders();
  }, [
    searchValues[section.id]?.GRUCAB?.value,
    searchValues[section.id]?.USUCAB?.value,
  ]);

  useEffect(() => {
    if (
      "header" in customUpdate.current &&
      typeof customUpdate.current.header === "number"
    ) {
      let tempHeaders = headersList;
      tempHeaders[customUpdate.current.header] = customUpdate.current.info;
      setHeadersList([...tempHeaders]);
      customUpdate.current = {};
    }
  }, [customUpdate.current]);

  return "GRUCAB" in searchValues[section.id] ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={headerTitles}
        data={headersList}
        onDoubleClick={openHeaderInfo}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
